import { render, staticRenderFns } from "./LlpgSearch.vue?vue&type=template&id=2548d398&"
import script from "./LlpgSearch.vue?vue&type=script&lang=js&"
export * from "./LlpgSearch.vue?vue&type=script&lang=js&"
import style0 from "./LlpgSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports